<script lang="ts">
  import type { Choice, Verification } from "./UpdateBookingDetailsTask/types";
  import type { Workflow as WorkflowObj } from "../lib/workflow/workflowLib.svelte";
  import Form from "../components/Form.svelte";
  import Workflow from "../lib/workflow/Workflow.svelte";
  import Step from "../lib/workflow/PersistentStep.svelte";
  import ChooseOption from "./UpdateBookingDetailsTask/ChooseOption.svelte";
  import UploadBookingConfirmation from "./UpdateBookingDetailsTask/UploadBookingConfirmation.svelte";
  import ConfirmBookingDetails from "./UpdateBookingDetailsTask/ConfirmBookingDetails.svelte";
  import { tick } from "svelte";

  let {
    action,
    createUploadSessionUrl,
    uploadAttachmentExtensions,
    detailsToVerify,
    explanation,
    verifications,
    errors,
  }: {
    action: string;
    createUploadSessionUrl: string;
    uploadAttachmentExtensions: string[];
    detailsToVerify: string;
    explanation: string;
    verifications: Verification[];
    errors: { [key: string]: string } | undefined;
  } = $props();

  let choice = $state<Choice>("upload");
  let workflow = $state<WorkflowObj | undefined>(undefined);

  async function goToUpload() {
    choice = "upload";
    await tick();
    workflow?.step("upload");
  };
</script>

<Form method="put" {action} class="ui-rhythm">
  <input type="hidden" name="choice" bind:value={choice}>
  <Workflow bind:workflow>
    <Step>
      <ChooseOption bind:choice {detailsToVerify} {errors} />
    </Step>
    <Step disabled={choice !== "upload"} path="upload">
      <UploadBookingConfirmation {createUploadSessionUrl} {uploadAttachmentExtensions} {errors} />
    </Step>
    <Step disabled={choice !== "details"}>
      <ConfirmBookingDetails {verifications} {explanation} {goToUpload} {errors} />
    </Step>
  </Workflow>
</Form>
